import { cn } from "@/lib/utils";

interface BrandIconProps {
  className?: string;
}

export function GoogleLogo({ className }: BrandIconProps) {
  return (
    <svg className={cn("shrink-0", className)} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
    </svg>
  );
}

export function AppleLogo({ className }: BrandIconProps) {
  return (
    <svg className={cn("shrink-0", className)} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.543 12.788c-.022-2.31 1.886-3.418 1.972-3.471-1.075-1.572-2.748-1.787-3.346-1.811-1.425-.144-2.78.84-3.504.84-.722 0-1.838-.819-3.022-.796-1.555.023-2.99.904-3.79 2.295-1.617 2.803-.414 6.954 1.16 9.232.77 1.115 1.687 2.366 2.89 2.322 1.16-.046 1.598-.751 3.001-.751 1.402 0 1.797.751 3.022.726 1.247-.022 2.038-1.137 2.802-2.257.882-1.295 1.246-2.55 1.268-2.616-.028-.012-2.43-.932-2.453-3.713zM15.236 5.91c.64-.776 1.072-1.853.954-2.926-.922.038-2.04.614-2.701 1.388-.593.687-1.111 1.783-.972 2.834 1.029.08 2.077-.522 2.719-1.296z" />
    </svg>
  );
}

export function FacebookLogo({ className }: BrandIconProps) {
  return (
    <svg className={cn("shrink-0", className)} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#1877F2" d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.469H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.312 0 2.686.234 2.686.234v2.953H15.83c-1.491 0-1.956.925-1.956 1.875V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z" />
      <path fill="#FFFFFF" d="M16.671 15.469L17.203 12h-3.328V9.75c0-.949.465-1.875 1.956-1.875h1.514V4.922s-1.374-.234-2.686-.234c-2.741 0-4.533 1.66-4.533 4.668V12H7.078v3.469h3.047v8.385a12.09 12.09 0 003.75 0v-8.385h2.796z" />
    </svg>
  );
}

export function AppStoreLogo({ className }: BrandIconProps) {
  return (
    <svg className={cn("shrink-0 fill-current", className)} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11" />
    </svg>
  );
}

export function PlayStoreLogo({ className }: BrandIconProps) {
  return (
    <svg className={cn("shrink-0 fill-current", className)} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-1.38l2.5 1.448a1 1 0 0 1 0 1.45l-2.5 1.448-2.533-2.533 2.533-2.812zM5.864 3.455L16.8 9.788l-2.302 2.302-8.635-8.635z" />
    </svg>
  );
}
